import request from "@utils/request";

export function getTransaction (query) {
    return request({
        url: "search/transaction",
        method: "post",
        data: query
    });
}